import {create} from 'zustand';
import {devtools} from 'zustand/middleware';

import type {InteractionState} from '../types';

const INITIAL_STATE = {
  partnersTypeList: '',
  disabledButton: '',
  productsCnae: [],
  haveOnlyPsrMigratedSelected: false,
  dotTyping: false
};

export const useInteractionStore = create<InteractionState>()(
  devtools(
    (set) => ({
      ...INITIAL_STATE,

      setPartnersTypeList: (typeList) =>
        set(
          {partnersTypeList: typeList},
          false,
          'interaction/setPartnersTypeList'
        ),

      disabledButtonSendMessage: (disabled) =>
        set(
          {disabledButton: disabled},
          false,
          'interaction/disabledButtonSendMessage'
        ),

      productsDiscoveryCnae: (products) =>
        set(
          {productsCnae: products},
          false,
          'interaction/productsDiscoveryCnae'
        ),

      setHaveOnlyPsrMigratedSelected: (flag) =>
        set(
          {haveOnlyPsrMigratedSelected: flag},
          false,
          'interaction/setHaveOnlyPsrMigratedSelected'
        ),

      setDotTyping: (dotTyping) =>
        set({dotTyping}, false, 'interaction/setDotTyping')
    }),
    {name: 'InteractionStore'}
  )
);

// Selectors
export const selectPartnersTypeList = (state: InteractionState) =>
  state.partnersTypeList;
export const selectDisabledButton = (state: InteractionState) =>
  state.disabledButton;
export const selectProductsCnae = (state: InteractionState) =>
  state.productsCnae;
export const selectHaveOnlyPsrMigratedSelected = (state: InteractionState) =>
  state.haveOnlyPsrMigratedSelected;
export const selectDotTyping = (state: InteractionState) => state.dotTyping;
